import { useToast } from '@jaymathew/ui-shared/contexts/ToastContext'
import { useMutation } from '@tanstack/react-query'
import { editUserNotification, EditUserNotificationInput } from 'API/notificationService'
import { HttpsCallableResult } from 'firebase/functions'

interface MutationCallbacks {
	onSuccess?: (data: HttpsCallableResult<unknown>) => void
	onError?: (err: Error) => void
}

export const useEditUserNotificationMutation = (callbacks: MutationCallbacks = {}) => {
	const { triggerToast } = useToast()

	return useMutation<HttpsCallableResult<unknown>, Error, EditUserNotificationInput>({
		mutationFn: editUserNotification,
		onSuccess: (data) => {
			triggerToast('Notification updated successfully', 'success')
			callbacks.onSuccess?.(data)
		},
		onError: (err) => {
			triggerToast(err.message, 'error')
			callbacks.onError?.(err)
		},
	})
}
